import React from 'react'

export const ImageInput = (props) => {
  return (
    <div>ImageInput</div>
  )
}
